/// <amd-module name="Pipeline/Analytics/DurationMetricsTrendCard/Actions/DurationMetricsTrendCardActions" />
import { ITrendChartData } from "Analytics/Shared/TrendChart/Common/Types";
import { PipelineReportBaseActions } from "Pipeline/Analytics/Common/Actions/PipelineReportBaseActions";
import { IMaxDurationTaskData, IPipelineDurationData } from "Pipeline/Analytics/PipelineDurationCommon/Types";
import { Action } from "VSS/Reflux/Action";

export class DurationMetricsTrendCardActions extends PipelineReportBaseActions<ITrendChartData> {
    public updatePipelineDurationDataAction: Action<IPipelineDurationData> = new Action<IPipelineDurationData>();
    public updateInsightsDataAction: Action<IMaxDurationTaskData> = new Action<IMaxDurationTaskData>();
}
